/* ============================================================
   KD custom script, part 3. Opened Thu 9/10/2026 for the
   "In Their Words" reviews band (section kd_testimonials_band).
   Companion to kd-custom-18.css. Deferred, touches only that one
   section, and safe to delete: nothing else depends on it.

   WHY IT EXISTS. The Testimonials section has two layout modes
   and neither one alone did what KD asked for:
     Autoplay ON  = a ticker marquee. It moves by itself, but the
                    theme renders NO arrows in that mode.
     Autoplay OFF = a Flickity slider. testimonials.js builds it
                    with prevNextButtons true, so the arrows are
                    there, but nothing advances on its own.
   She wanted arrows AND automatic movement, so the section is set
   to Autoplay OFF (slider, arrows) and this file advances it.

   It also makes a whole card clickable through to the reviews
   page, and strips the weekday off each card's date.

   DIALS: ADVANCE_MS how long each page of cards rests,
   REVIEWS_URL where a card click goes.
   ============================================================ */
(function () {
  'use strict';

  var REVIEWS_URL = '/pages/reviews';
  var ADVANCE_MS = 4500;

  function getSection() {
    return document.querySelector('[data-section-type="testimonials"]');
  }

  /* ---- 1. dates show without a weekday ----
     KD 9/11: "rid of day of week". On this band the date is literal
     text in each block's subheading in templates/index.json, saved
     as "Mon Sep 7, 26", so CSS cannot drop the word and the only
     other route is rewriting index.json. That is the 46KB file two
     chats have already clobbered, and the weekly refresh rewrites
     these dates anyway, so the weekday is removed at render here
     instead. Idempotent: once a date is clean the pattern no longer
     matches, so a refresh that writes dates already in the new
     format simply passes straight through. */
  var WEEKDAY = /^\s*(Sun|Mon|Tue|Wed|Thu|Fri|Sat)[a-z]*\.?,?\s+/i;

  function stripWeekdays(section) {
    var dates = section.querySelectorAll('.testimonial__user .testimonial__subheading');
    Array.prototype.forEach.call(dates, function (el) {
      var target = el.querySelector('p') || el;
      var text = target.textContent;
      if (WEEKDAY.test(text)) target.textContent = text.replace(WEEKDAY, '');
    });
  }

  /* ---- 2. the whole card is a link to the reviews page ---- */
  function makeCardsClickable(section) {
    var cards = section.querySelectorAll('.testimonial__item');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.getAttribute('data-kd-linked')) return;
      card.setAttribute('data-kd-linked', '1');
      card.style.cursor = 'pointer';
      card.setAttribute('role', 'link');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-label', 'Read more customer reviews');

      card.addEventListener('click', function (e) {
        /* let a real link or button inside the card win */
        if (e.target.closest && e.target.closest('a, button')) return;
        /* do not treat the end of a drag as a click */
        var slider = card.closest('testimonials-slider');
        if (slider && slider.classList.contains('is-dragging')) return;
        window.location.href = REVIEWS_URL;
      });

      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          window.location.href = REVIEWS_URL;
        }
      });
    });
  }

  /* ---- 3. advance the slider on its own, arrows still work ---- */
  function startAutoAdvance(section) {
    var slider = section.querySelector('testimonials-slider');
    if (!slider) return false;
    if (!window.theme || !window.theme.Flickity) return false;

    var flkty = window.theme.Flickity.data(slider);
    if (!flkty || !flkty.isActive) return false;
    if (slider.getAttribute('data-kd-auto')) return true;
    slider.setAttribute('data-kd-auto', '1');

    /* respect a reduced-motion preference: arrows only, no drift */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return true;
    }

    var timer = null;
    function start() {
      if (timer) return;
      timer = setInterval(function () {
        if (document.hidden) return;
        flkty.next(true);
      }, ADVANCE_MS);
    }
    function stop() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    }

    /* pause while someone is reading or driving it themselves */
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);

    var buttons = section.querySelectorAll('.flickity-button');
    Array.prototype.forEach.call(buttons, function (b) {
      b.addEventListener('click', function () {
        stop();
        setTimeout(start, ADVANCE_MS * 2);
      });
    });

    start();
    return true;
  }

  function init() {
    var section = getSection();
    if (!section) return;

    stripWeekdays(section);
    makeCardsClickable(section);

    /* Flickity is built by testimonials.js after this file runs, and
       it destroys and rebuilds itself on resize, so poll briefly
       rather than assuming it is ready. Weekdays are stripped again
       on each pass, because a rebuild can re-render cells from the
       original markup. */
    var tries = 0;
    var poll = setInterval(function () {
      tries += 1;
      stripWeekdays(section);
      if (startAutoAdvance(section) || tries > 40) clearInterval(poll);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();